
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { LOCALS } from "./Locals";


i18next.use(initReactI18next)
    .init({
        resources: LOCALS,
        interpolation: {
            escapeValue: false
        }
    });

export default i18next;